import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import CssBaseline from "@mui/material/CssBaseline";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import SaveIcon from "@mui/icons-material/Save";
import { toast } from "react-toastify";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import * as userApi from "../../api/userApi";
import * as companyApi from "../../api/companyApi";

export default class NewUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newUser: {
        newPassword: "",
        admin: 0,
        fno: 0,
        tff: 0,
        yff: 0,
        gk: 0,
        userName: "",
        fullName: "",
        userEmail: "",
        companyId: 0,
        activeUser: true,
      },
      signedInUser: {},
      companies: [],
      errors: {},
      message: "",
    };
  }

  async componentDidMount() {
    try {
      const userName = sessionStorage.getItem("token")
        ? JSON.parse(sessionStorage.getItem("token")).userName
        : "";

      if (userName) {
        const signedInUser = await userApi.getUser(userName);
        if (signedInUser) {
          this.setState({ signedInUser: signedInUser[0] });
        }
      }
      this.getCompanies();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getCompanies = async () => {
    const companies = await companyApi.getCompanies();
    if (companies) {
      companies.sort((a, b) => {
        if (a.companyName < b.companyName) return -1;
        if (a.companyName > b.companyName) return 1;
        return 0;
      });
      this.setState({ companies });
    }
  };

  onChange = (e) => {
    try {
      const name = e.target.name;
      const value = e.target.value;
      const errors = { ...this.state.errors };
      errors[name] = "";
      this.setState({ errors });

      const newUser = { ...this.state.newUser };
      newUser[name] = value;
      this.setState({ newUser });
    } catch (error) {
      console.log("Error in onChang", error);
    }
  };

  handleCheckboxChange = (e) => {
    try {
      const newUser = { ...this.state.newUser };
      newUser[e.target.name] = e.target.checked ? 1 : 0;
      this.setState({ newUser });
    } catch (error) {
      console.log("Error in handleCheckboxChange", error);
    }
  };

  onSave = async (event) => {
    try {
      event.preventDefault();
      if (!this.formIsValid()) return;
      let status = await userApi.createNewUser(this.state.newUser);
      if (
        status === "Password does not meet the requirements." ||
        status === "Insuficient Admin password strength"
      ) {
        const errors = {};
        errors.newPassword =
          "Passordet må være minst 10 tegn (16 tegn for Admin). Må innholde minst én liten bokstav, én stor bokstav, ett tall og ett spesialtegn.";
        this.setState({ errors });
        return;
      }
      if (status === "Password previously used.") {
        const errors = {};
        errors.newPassword =
          "Passordet må ikke være samme som de 13 forrige. Velg et nytt passord";
        this.setState({ errors });
        return;
      }
      if (status === "User Exists") {
        const errors = {};
        errors.message = "E-post eksisterer";
        this.setState({ errors });
        return;
      }
      if (status) {
        toast.success("Ny bruker lagret.");
      } else {
        toast.error("Det skjedd noe feil...");
      }
    } catch (error) {
      throw error;
    }
  };

  formIsValid = () => {
    const {
      companyId,
      newPassword,
      repeatPassord,
      admin,
      fno,
      tff,
      yff,
      gk,
    } = this.state.newUser;
    const errors = {};
    if (!companyId) errors.companyId = "Velg bedrift";
    if (newPassword && !repeatPassord) {
      errors.repeatPassord = "   ";
    } else if (repeatPassord && !newPassword) {
      errors.newPassword = "   ";
    } else if (newPassword && repeatPassord && newPassword !== repeatPassord) {
      errors.repeatPassord = "Password og Gjentatt passord må være samme";
    }
    if (admin === 0 && fno === 0 && tff === 0 && yff === 0 && gk === 0) {
      errors.roles = "* Velg minst en rolle";
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  render() {
    const layout = {
      width: "100%",
      paddingTop: 80,
    };

    const paper = {
      paddingLeft: 30,
      paddingTop: 20,
    };

    const gridPaddingTop = {
      paddingTop: 20,
    };

    return (
      <Container maxWidth="lg">
        <form>
          <main style={layout}>
            <Paper style={paper}>
              <React.Fragment>
                <CssBaseline />
                <h1>Ny bruker</h1>
                <Grid container spacing={3}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Typography style={{ color: "red" }}>
                      {this.state.errors.message}
                    </Typography>
                    <Grid>
                      <TextField
                        autoComplete="off"
                        variant="standard"
                        name="userEmail"
                        label="E-post"
                        type="email"
                        value={this.state.newUser.userEmail || ""}
                        onChange={this.onChange}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid style={gridPaddingTop}>
                      <TextField
                        variant="standard"
                        name="fullName"
                        label="Navn"
                        value={this.state.newUser.fullName || ""}
                        onChange={this.onChange}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid style={gridPaddingTop}>
                      <FormControl variant="standard" required fullWidth>
                        <InputLabel>Bedrift</InputLabel>
                        <Select
                          name="companyId"
                          value={this.state.newUser.companyId || ""}
                          onChange={this.onChange}
                          error={Boolean(this.state.errors.companyId)}
                          helpertext={this.state.errors.companyId || ""}
                        >
                          {this.state.companies.map((company, index) => (
                            <MenuItem key={index} value={company.companyId}>
                              {company.companyName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid style={gridPaddingTop}>
                      <h3>Endre passord</h3>
                      <TextField
                        autoComplete="new-password"
                        variant="standard"
                        name="newPassword"
                        label="Passord"
                        type="password"
                        value={this.state.newUser.newPassword || ""}
                        onChange={this.onChange}
                        fullWidth
                        required
                        error={Boolean(this.state.errors.newPassword)}
                        helpertext={this.state.errors.newPassword || ""}
                      />
                    </Grid>
                    <Typography style={{ color: "red" }}>
                      {this.state.errors.newPassword}
                    </Typography>

                    <Grid style={gridPaddingTop}>
                      <TextField
                        autoComplete="new-password"
                        variant="standard"
                        name="repeatPassord"
                        label="Gjenta passord"
                        type="password"
                        value={this.state.newUser.repeatPassord || ""}
                        onChange={this.onChange}
                        fullWidth
                        required
                        error={Boolean(this.state.errors.repeatPassord)}
                        helpertext={this.state.errors.repeatPassord || ""}
                      />
                      <Typography style={{ color: "red" }}>
                        {this.state.errors.repeatPassord}
                      </Typography>
                    </Grid>

                    <Grid style={{ paddingTop: 30 }}>
                      <Button
                        startIcon={<SaveIcon />}
                        variant="contained"
                        color="primary"
                        onClick={this.onSave}
                      >
                        {"Lagre"}
                      </Button>
                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <h4>Tilganger</h4>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="admin"
                          checked={this.state.newUser.admin === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                          disabled={this.state.signedInUser.admin === 0}
                        />
                      }
                      label="Admin"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="fno"
                          checked={this.state.newUser.fno === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                          disabled={this.state.signedInUser.admin === 0}
                        />
                      }
                      label="FNO"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="tff"
                          checked={this.state.newUser.tff === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                        />
                      }
                      label="TFF"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="yff"
                          checked={this.state.newUser.yff === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                        />
                      }
                      label="YFF"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="gk"
                          checked={this.state.newUser.gk === 1}
                          onChange={this.handleCheckboxChange}
                          color="primary"
                        />
                      }
                      label="GK"
                    />
                    <Typography style={{ color: "red" }}>
                      {this.state.errors.roles}
                    </Typography>

                    <h4 style={gridPaddingTop}>Status</h4>
                    <RadioGroup row>
                      <FormControlLabel
                        control={<Radio color="primary" />}
                        checked={this.state.newUser.activeUser === true}
                        label="Aktiv"
                        labelPlacement="end"
                        disabled
                      />
                      <FormControlLabel
                        control={<Radio color="primary" />}
                        checked={this.state.newUser.activeUser === false}
                        label="Inaktiv"
                        labelPlacement="end"
                        disabled
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
              </React.Fragment>
            </Paper>
          </main>
        </form>
      </Container>
    );
  }
}
